<template>
  <div>
    <ais-refinement-list :ref="urlParam" :attribute="attribute" :limit="limit" :sort-by="['name:asc']">
      <template slot-scope="{ items, refine}">
        <div>
          <clear-refinements :attribute="attribute" v-if="hasSelectedFacets(items)"/>
          <h6 class="font-weight-bold text-dark mb-2" v-if="items.length">
            {{ title }}
          </h6>
        </div>
        <div class="mb-3 border-bottom pb-3" v-if="items.length" :data-refinement="attribute" :data-url-label="urlParam" >
          <div :href="item.url" @click.prevent="refine(item.value)" :data-isRefined="item.isRefined" v-for="item in items" :key="item.value" class="py-2 mb-1 clickable badge-pill badge-light mr-1 text-left" :class="{active: item.isRefined, 'btn-block': btnBlock}">
            <div class="d-flex" v-if="item.isRefined">
              <div>
                <i class="material-icons text-success">check_circle</i>
              </div>
              <div class="container pl-2 font-weight-bold">
                {{ itemLabel(item.label) }}
              </div>
            </div>
            <div class="d-flex" v-else>
              <div>
                <i class="material-icons text-white">check_circle</i>
              </div>
              <div class="container pl-2">
                {{ itemLabel(item.label) }}
              </div>
            </div>
          </div>
        </div>
      </template>

    </ais-refinement-list>

</div>
</template>

<script>

  import ClearRefinements from './widgets/ClearRefinements.vue';

  export default {
    name: 'Filters',

    components: {
      ClearRefinements,
    },
    props: {
      title: {
        type: String,
        default: '',
      },
      limit: {
        type: Number,
        default: 10,
      },
      urlParam: {
        type: String,
        default: '',
      },
      btnBlock: {
        type: Boolean,
        default: false,
      },
      attribute: {
        type: String,
        default: '',
      },
    },
    mounted() {
    },
    methods: {
      hasSelectedFacets(items) {
        return items.some(i => i.isRefined);
      },
      itemLabel(label) {
        switch(this.attribute) {
          case 'accountLock':
          return label === '1' ? 'Deactivated' : 'Active';
          default:
          return label;
        }
      }
    },
  };

</script>
